import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { USER_STATUS_TEXT } from '../../../constants/user'
import { Status } from '../../Status'
import Text from '../../Text'

import * as styles from './UserListItemAdditionalInfo.module.css'

function UserListItemAdditionalInfo({
  blocked,
  email,
  emailRef,
  isHovered,
  status,
}) {
  const { t } = useTranslation()

  const emailClassName = classNames(styles.email, {
    [styles.blocked]: blocked,
    [styles.hover]: !blocked && isHovered,
  })

  return (
    <>
      {email && !Number.isFinite(status) ? (
        <Text isSecondary className={emailClassName} ref={emailRef}>
          {email}
        </Text>
      ) : null}
      {Number.isFinite(status) ? (
        <Status
          className={styles.chip}
          text={t(USER_STATUS_TEXT[status].text)}
          textColor={USER_STATUS_TEXT[status].color}
        />
      ) : null}
    </>
  )
}

export default UserListItemAdditionalInfo
